/**
 * 모듈 숙련도 도메인 부트스트래퍼 — 전용 숙련도 탭(모듈별 노드 해금 진행 + A/B 분기 선택).
 * 데이터 빌더(buildModuleMasteryData)는 순수 + 저렴(누진 루프 없음)이라 signature 생략 — 매 refresh update.
 */
import { ModuleMasteryTabView } from "../ui/ModuleMasteryTabView.js";
import { buildModuleMasteryData } from "../ui/moduleMasteryTabData.js";
import { buildModuleInfoDataFromDef } from "../ui/tabData.js";
import { viewTabHandle } from "@yjsgames/phaser-ui/tab-registry";
import type { DomainBootstrapper, GameBoot } from "./BootTypes.js";

export const moduleMasteryBoot: DomainBootstrapper = {
  key: "moduleMastery",
  install(boot) {
    boot.tabs.registerLazy("moduleMastery", {
      mount: () => {
        const { tabContent } = boot.layout;
        const view = new ModuleMasteryTabView(
          boot.scene,
          tabContent.x,
          tabContent.y,
          tabContent.width,
          boot.layout.shell.tabPanelBottom,
          {
            onSelectBranch: (moduleId, branch) =>
              boot.progression.selectMasteryBranch(moduleId, branch),
            onOpenModuleInfo: (moduleId) => openMasteryModuleInfo(boot, moduleId),
          },
        );
        return viewTabHandle(view, () =>
          view.update(
            buildModuleMasteryData(boot.ctx.moduleMastery(), {
              moduleLevel: (moduleId) => boot.ctx.playerModuleLevels().level(moduleId),
            }),
          ),
        );
      },
    });
  },
};

/** 숙련도 카드 아이콘 클릭 — 도감과 같은 정의 기준 모듈 정보 팝업. */
function openMasteryModuleInfo(boot: GameBoot, moduleId: string): void {
  const def = boot.ctx.moduleRegistry().getDefinition(moduleId);
  if (!def) return;
  const screen = boot.screen();
  boot.modals.openModuleInfo({
    screenWidth: screen.width,
    screenHeight: screen.height,
    onClose: () => boot.modals.closeModuleInfo(),
  });
  boot.modals.updateModuleInfo(
    buildModuleInfoDataFromDef(
      def,
      boot.ctx.playerModuleLevels().level(moduleId),
      false,
      boot.ctx.chapter().bestChapter,
    ),
  );
}
